import { render, staticRenderFns } from "./sitemap-tree-item.vue?vue&type=template&id=7eda4556"
import script from "./sitemap-tree-item.vue?vue&type=script&lang=ts"
export * from "./sitemap-tree-item.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7eda4556')) {
      api.createRecord('7eda4556', component.options)
    } else {
      api.reload('7eda4556', component.options)
    }
    module.hot.accept("./sitemap-tree-item.vue?vue&type=template&id=7eda4556", function () {
      api.rerender('7eda4556', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "templates/sitemap-tree-item.vue"
export default component.exports